import React, { FunctionComponent } from 'react';
import styles from './employee-box.module.scss';
import {
  SocialMediaIcon,
  properOrderForSocialMedia
} from './social-media/social-media';
import { ExternalLink } from '../external-link/external-link';

export interface IEmployeeBoxProps extends React.PropsWithChildren<{}> {
  firstName: string | null;
  lastName: string | null;
  position: string | null;
  photoUrl: string | null;
  contact: IEmployeeBoxPropsContact[];
  email: string | null;
  hasAuthorPage: boolean;
  biography: string | null;
  slug: string;
}

export interface IEmployeeBoxPropsContact {
  icon: string;
  url: string;
}

export const EmployeeBox: FunctionComponent<IEmployeeBoxProps> = props => {
  const socialMediaInProperOrder =
    properOrderForSocialMedia(props.contact) || [];
  return (
    <div
      className={styles.employeeBoxContainer}
      style={{ backgroundImage: `url(${props.photoUrl})` }}
    >
      <div className={styles.employeeBoxData}>
        <div
          className={styles.personHeader}
        >{`${props.firstName} ${props.lastName}`}</div>
        <div className={styles.personPosition}>{props.position}</div>

        <div className={styles.contactContainer}>
          {socialMediaInProperOrder.map(item => (
            <ExternalLink key={item.icon} url={item.url}>
              <SocialMediaIcon icon={item.icon} className={styles.icon} />
            </ExternalLink>
          ))}
        </div>
      </div>
    </div>
  );
};
